import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { muiTheme } from "./theme/muiTheme";
import { ScaleProvider } from "./providers/DetectScaleContext";
import RootRoutes from "./routes/RootRoutes";
import { SidebarProvider } from "./components/ui/sidebar";
import { Toaster } from "./components/ui/sonner";
import { ErrorModalProvider } from "./components/ErrorModal";
const queryClient = new QueryClient();

function App() {
  return (
    <>
      <MuiThemeProvider theme={muiTheme}>
        <QueryClientProvider client={queryClient}>
          <ScaleProvider>
            <SidebarProvider>
              <ErrorModalProvider>
                <div className="app-container">
                  <RootRoutes />
                </div>
              </ErrorModalProvider>
            </SidebarProvider>
          </ScaleProvider>
        </QueryClientProvider>
      </MuiThemeProvider>
      <Toaster />
    </>
  );
}

export default App;
